export default __webpack_public_path__ + "static/media/panItaliano.6c758111.png";